import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["english", "arabic"]

    connect() {
        // Initialize by resetting to the default language (page current localization)
        this.reset()
    }

    /**
     * Handles the language switch event.
     * @param {Event} event - The event triggered by the language switch action.
     */
    switch(event) {
        const selectedLanguage = event.target.value
        this.showSelectedLanguage(selectedLanguage)
    }

    /**
     * Displays the selected language and hides others.
     * @param {string} language - The language to display ("en" or "ar").
     */
    showSelectedLanguage(language) {
        switch (language) {
            case "en":
                this.toggleVisibility(this.englishTarget, true)
                this.toggleVisibility(this.arabicTarget, false)
                break
            case "ar":
                this.toggleVisibility(this.englishTarget, false)
                this.toggleVisibility(this.arabicTarget, true)
                break
            default:
                console.warn(`Unsupported language: ${language}`)
                break
        }
    }

    /**
     * Resets the language display to the default (page current localization).
     */
    reset() {
        const defaultLanguage = document.documentElement.lang || "en"
        if (!["en", "ar"].includes(defaultLanguage)) {
            console.warn(`Unsupported default language: ${defaultLanguage}. Falling back to English.`)
            this.showSelectedLanguage("en")
        } else {
            this.showSelectedLanguage(defaultLanguage)
        }
    }

    /**
     * Toggles the visibility of a target element.
     * @param {HTMLElement} target - The target element to show or hide.
     * @param {boolean} show - Whether to show (`true`) or hide (`false`) the element.
     */
    toggleVisibility(target, show) {
        if (!target) {
            console.error("Target element is missing.")
            return
        }
        target.classList.toggle("hidden", !show)
        target.setAttribute("aria-hidden", !show) // Improves accessibility for screen readers
    }
}
